
export const host = process.env.NODE_ENV==="development" ?'http://localhost:7000': 'https://mongo-db-backend.herokuapp.com'